export default "__VITE_ASSET__Bn45Xi_g__"